var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.message,
    placement: 'bottom-center',
    classes: ['info', _vm.widthType],
    offset: 5,
    html: true,
    delay: {
      show: 200,
      hide: 100,
    },
  }),expression:"{\n    content: message,\n    placement: 'bottom-center',\n    classes: ['info', widthType],\n    offset: 5,\n    html: true,\n    delay: {\n      show: 200,\n      hide: 100,\n    },\n  }"}],staticClass:"tooltip-icon"},[_c('div',{ref:"fakeElement",staticStyle:{"display":"none"}},[_vm._t("default")],2),_c('div',{staticClass:"icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }